export const getLocale = () => {
  if (navigator.languages?.length) {
    return navigator.languages[0];
  }
  return navigator.userLanguage || navigator.language;
};
